import {useDispatch} from "react-redux";
import React, {useEffect} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {
    getListaCabecalhoOSRecapados

} from "../../../actions/i4Actions";
import ProducaoMensalBandasView from "./ProducaoMensalBandasView";
import {getSOTiresStatistics} from "../../../actions/serviceOrderStatistics";



const useStyles = makeStyles(theme => ({
    mainGrid:{
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center'

    },

    dashboardSection: {
        // padding: "5px"
    },
    sectionTitle: {
        marginBottom: theme.spacing(1) * 4,
        marginTop: theme.spacing(1) * 4
    },
    marginTop: {
        marginTop: theme.spacing(1) * 4
    },
    marginBottom: {
        marginBottom: theme.spacing(1) * 5,
    },
    marginBottomCharts: {
        margin: theme.spacing(1) * 3,
    },
    marginRight: {
        paddingRight: theme.spacing(1) * 2
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
}));

const today = new Date();

const PainelTVBandas = ( props ) => {
    const classes = useStyles();

    const dispatch = useDispatch();


    useEffect( () => {


        dispatch(getListaCabecalhoOSRecapados())
        dispatch(getSOTiresStatistics())

            props.setTitulo("PRODUÇÃO - MÊS - BANDAS")

    }, [props.contador]);


    return (
        <React.Fragment>
                        <ProducaoMensalBandasView/>
        </React.Fragment>
    )

}
export default (PainelTVBandas);


